import { PropsWithChildren, useState, JSX } from 'react'
import Popup from '../components/Popup'
import { PopupContext } from '../contexts/Popup.context'

const PopupProvider = ({ children }: PropsWithChildren) => {
  const [popup, setPopup] = useState<JSX.Element | null>(null)

  const closePopup = () => setPopup(null)

  return (
    <PopupContext.Provider
      value={{
        closePopup,
        setPopup,
      }}
    >
      {children}
      <Popup content={popup} active={!!popup} close={closePopup} />
    </PopupContext.Provider>
  )
}

export default PopupProvider
